import React, { useEffect, useState } from "react";
import { useForm} from "react-hook-form";
import * as CONSTANTS from "../../utils/CONSTANTS";
import DropDownListselect from "../../components/dropdown";
import { FormAreaInput } from "../../wrappers/formArea";
import {removeDetails} from './services';

export type certificationsFormFields = {
  skills: any
  certificationType: any
}

interface props {
  onClose?: any;
  ClickHandler?: any;
  defaultValues?: any;
  register?: any;
  key?: any;
  removeId?:any;
  remove?:any;
  updatedData?:any;
  setUpdatedData?: any;
  loginId?:any;
  setErrorSkillsData?:any;
  errorSkillsData?:any;
  setErrorCertificateData?:any;
  errorCertificateData?:any;
  keyidd?:any;
  showValidationMessage?:any;
  errorNoteData?:any;
  setErrorNoteData?:any;
}

const CertificationForm: React.FC<props> = ({
  onClose,
  ClickHandler,
  defaultValues,
  register,
  key,
  removeId,
  remove,
  updatedData,
  setUpdatedData,
  loginId,
  setErrorSkillsData,
  errorSkillsData,
  setErrorCertificateData,
  errorCertificateData,
  keyidd,
  showValidationMessage,
  errorNoteData,
  setErrorNoteData,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { handleSubmit, control, reset, setValue, formState ,watch} = useForm<certificationsFormFields>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [keyid,SetKeyid]=useState<any>(keyidd);
  const [certificate, setcertificate] = useState<any>({skills:defaultValues.skills?defaultValues.skills:{name:'',id:''},certificationType:defaultValues.certificationType?defaultValues.certificationType:'',certificationId:defaultValues.certificationId?defaultValues.certificationId:null,key:keyid,notes:defaultValues.notes?defaultValues.notes:null})
  const checkskills=defaultValues.skills?'':'Field is Required'
  const checkCertification=defaultValues.certificationType?'':'Field is Required'   
  const [errorSkills,SetErrorSkills]=useState<any>(checkskills)
  const [errorCertification,SetErrorCertification]=useState<any>(checkCertification)
  const [showNote,SetShowNote]=useState<any>(false)
  const [errorNote,SetErrorNote]=useState<any>('')
  const userloginId = localStorage.getItem("loginId")
      
  useEffect(() => {
 
    if(checkCertification !== ''){
      setErrorCertificateData( [...errorCertificateData,keyid])
    }
    updatedData.push(certificate)
    setUpdatedData(updatedData)
    if(defaultValues.certificationType === 'Others'){
      if(defaultValues.notes==null){
        SetErrorNote('Field is Required');
        setErrorNoteData([...errorSkillsData,keyid])
      }
      SetShowNote(true)
    }     
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onremove = (keyid:number) => {
    setErrorSkillsData( errorSkillsData.filter((item: any) => item !== keyid))
    SetErrorNote(errorNoteData.filter((item: any) => item !== keyid))
    setErrorCertificateData(errorCertificateData.filter((item: any) => item !== keyid))
    const certificatedata: { skills: any; certificationType: any; certificationId: any; key: any,notes:any }[]=[]
    const removecertificatedata: { skills: any; certificationType: any; certificationId: any; key: any,notes:any }[]=[]
    // eslint-disable-next-line array-callback-return
    updatedData.map((newdata:any)  => {
      let n=newdata;       
      if(newdata.key !== keyid){
        certificatedata.push(n)
      }
      else{
        removecertificatedata.push(n)
      }
    })

    const removecertificationpayload=removecertificatedata.map(function(item:any) { 
      delete item.key
      return item
    })
 
    var payload={
      loginId : loginId,
      userLoginId:userloginId,
      profileMetadata:{ "ellowScreeningCertifications":removecertificationpayload }
    }
    removeDetails(payload)  
  }

  const onChangeskills = (e:any,updateId:number) => {
    SetErrorSkills('');
    setErrorSkillsData( errorSkillsData.filter((item: any) => item !== keyid))
    setcertificate({...certificate,skills:{name:e.value.name,id:e.value.id}})
    const n=  updatedData.map((item:any) => {
      if (item.key === updateId) {
        return {...certificate,skills:{name:e.value.name,id:e.value.id}}
      } else {
        return item
      }
    })
    setUpdatedData(n)
  }

  const onChangeNote = (e:any,updateId:number) => {
    if(e.target.value !== ''){
      setErrorNoteData(errorNoteData.filter((item: any) => item !== keyid))
      SetErrorNote('');
      setcertificate({...certificate,notes:e.target.value})
      const n=  updatedData.map((item:any) => {
        if (item.key === updateId) {
          return {...certificate,notes:e.target.value};
        } else {
          return item;
        }
      })
      setUpdatedData(n)
    }
    else{
      setErrorNoteData([...errorNoteData,keyid])
      SetErrorNote('Field is Required')
    }
  }

  const onChangecertificate = (e:any,updateId:number) => {
    if(e.value.name === 'Others'){
      SetShowNote(true);
      if(certificate.notes==null){
        SetErrorNote('Field is Required')
        setErrorNoteData([...errorNoteData,keyid])
      }
    }
    else{
      SetErrorNote('')
      SetShowNote(false)
      setErrorNoteData(errorNoteData.filter((item: any) => item !== keyid))
      setcertificate({...certificate,notes:null})
      const n=  updatedData.map((item:any) => {
        if (item.key === updateId) {
          return {...certificate,notes:null}
        } else {
          return item
        }
      })
      setUpdatedData(n)
    }
    setErrorCertificateData(errorCertificateData.filter((item: any) => item !== keyid))
    SetErrorCertification('')
    setcertificate({...certificate,certificationType:e.value.name}) 
    const n=  updatedData.map((item:any) => {
      if (item.key === updateId) {
        return {...certificate,certificationType:e.value.name}
      } else {
        return item;
      }
    })
    setUpdatedData(n)
  }
    
let certificationData;
if(defaultValues.certificationType === 'Interview'){
  certificationData={ name: "Interview", id: 2 }
}
else if(defaultValues.certificationType === 'Test'){
  certificationData={ name: "Test", id: 1 }
}
else if(defaultValues.certificationType === 'Github Review'){
  certificationData={ name: "Github Review", id: 3 }
}
else if(defaultValues.certificationType === 'Others'){
  certificationData={ name: "Others", id: 4 };
}
else
{
  certificationData={};
}
  return (
    <>
    <div className="half-form-wrap">
      <div className="form-group">
        <label className="lablel">Skills*</label>
        <DropDownListselect
          name="skills"
          data={CONSTANTS.Skills}
          dataItemKey="id"
          textField="name"
          defaultValue={defaultValues.skills}
          onChange={(e:any) => onChangeskills(e,keyid)} 
        />
        <p className="redtext"> {showValidationMessage?errorSkills:''}</p>
      </div>
      <div className="form-group">
        <label className="lablel">Certified*</label>
        <DropDownListselect
          name="certificationType"
          data={CONSTANTS.certifications}
          onChange={(e: any) => onChangecertificate(e,keyid)}
          dataItemKey="id"
          defaultValue={certificationData}
          textField="name"
        />
        <p className="redtext">{showValidationMessage?errorCertification:''}</p>
      </div>
      <button type='button' className="k-button k-button-md k-button-rectangle k-button-flat k-button-flat-base k-rounded-md  k-icon-button  border-2" onClick={() => {onremove(keyid); remove(removeId) } }>
        <span role="presentation" className="k-button-icon k-icon k-i-x"></span>
      </button>
    </div>
    <div className="form-wrap wid-90">
      <div className="form-group">
        <FormAreaInput
          id="title"
          type="text"
          name="title"
          label={errorNote === '' ? 'Note' : 'Note*'}
          onChange={(e:any) => onChangeNote(e,keyid)}
          value={defaultValues.notes}
        />      
        { showNote ? <p className="redtext">{showValidationMessage ? errorNote : ''}</p> : '' }
      </div>
    </div>
    </>
  )
}
export default CertificationForm
